import { BreadcrumbsMap } from '../../components/breadcrumbs';

export const historyBreadcrumbs: BreadcrumbsMap = {
  '/history': 'History of edits',
};
